export class MDArtistBodyModel {
    constructor(
        public nameAsOnCertificate: string,
        public isStampReadable: string,
        public isStampFromRKS: string,
        public isSignaturePresent: string,
        public isDateOfIssuePresent: string,
        // public isQRCodePresent: string,
    ) { }
}